import {Point} from 'pixi.js';

import {BaseComponent} from '@specials/gcs-engine';
import {ParticleEmitter} from '@specials/particle-emitter';

export class EmitterPoolComponent extends BaseComponent {
  private emitterPool: ParticleEmitter[];
  private pointer: number;
  private poolSize: number;

  public init(emitterFactory: () => ParticleEmitter, poolSize: number = 1): void {
    this.pointer = 0;
    this.emitterPool = [];
    this.poolSize = Math.max(1, poolSize);

    for (let i = 0; i < this.poolSize; i++) {
      this.emitterPool.push(emitterFactory());
    }
  }

  public emitWave(spawnPos: Point): void {
    const emitter = this.emitterPool[this.pointer];
    emitter.config.spawnPosition = {
      x: spawnPos.x,
      y: spawnPos.y,
    };

    emitter.emitWave();

    this.incrementPointer();
  }

  private incrementPointer(): void {
    this.pointer = this.pointer === this.poolSize - 1 ? 0 : this.pointer + 1;
  }
}
